import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { BerthSelector } from "@/components/uis/BerthSelector";
import { IconLabelSelector } from "@/components/uis/IconLabelSelector";
import { SC } from "./graphql/query";
import { useContainer } from "./hooks/useContainer";
import styles from "./styles.module.css";
type BerthSelectBoxProps = {
  factoryId: string;
  selectedBerth: string;
  handleChange: (value: string) => void;
};
export const BerthSelectBox = SC<BerthSelectBoxProps>(({
  unloadingDocks,
  selectedBerth,
  handleChange
}) => {
  const {
    open,
    onClickSelectBox,
    onClickBerth
  } = useContainer({
    handleChange
  });
  return <>
        <FormControl className={styles.form}>
          <InputLabel id="berth-select-label">
            <IconLabelSelector type="berth" iconColor={"primary"} />
          </InputLabel>
          <Select labelId="berth-select-label" value={selectedBerth} onClick={onClickSelectBox} className={styles.select} open={false}>
            {unloadingDocks.map(dock => <MenuItem key={dock.id} value={dock.id}>
                {dock.name}
              </MenuItem>)}
          </Select>
        </FormControl>
        <BerthSelector open={open} cbFunc={onClickBerth} />
      </>;
});